import * as Graphql from "@hireroo/graphql/client/urql";

export const isValidReviewStatus = (status: Graphql.RemoteStatus): boolean => {
  const validReviewStatuses: Graphql.RemoteStatus[] = ["COMPLETED", "EVALUATED"];
  return validReviewStatuses.includes(status);
};
